import type SecurityService from "services/securityService";

export function allowToDownload(securityService: SecurityService): boolean {
  return securityService.allowTo("enforcement.reports", "read");
}
